import { Settings } from 'luxon';

import { SPAConfiguration, BreakPoint } from 'app.configuration';
import { AnalyticsAction } from 'cms/cms-shared/models/analytics-action/analytics-action.models';
import { CSSEditorStyles } from 'cms/common/ui/cms-text-editor/cms-text-editor-styles';
import { ContinentStoresConfig } from 'idt-ecommerce-api/stores/stores.models';


export { EcommerceBrandSettings, AppIdEnum } from 'idt-ecommerce-api/config/config.models';

Settings.defaultLocale = 'es';

export interface CmsConfiguration extends SPAConfiguration {
  activityCenterPollingIntervalMs?: number;
  audiencesFrontUrl?: string; // Same here
  jsonPublishedUrl: string;
  appPreviewBaseUrl: string;
  disableGuard?: boolean;
  disallowInsecure?: boolean;
  textStyles: TextStyle[];
  colorStyles: string[];
  groupStoresBySaleStatus?: boolean;
  storesGroup?: ContinentStoresConfig[];
  breakpoints: BreakPointPreview[];
  analyticsActionsTypes?: AnalyticsAction[];
  l10nBaseUrl: string;
  l10nAppCode: string;
}

export interface TextStyle {
  name: string;
  class: string;
  styles: CSSEditorStyles;
}

export interface BreakPointPreview extends BreakPoint {
  previewDimensions: {
    width: number;
    height: number;
  };
}
